import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import useFetchData from "../../../../hooks/useFetchData";
import axiosClient from "../../../../services/axiosClient";
import CheckBox from "./CheckBox";
import styles from "./ListRoleSelect.module.css";
import { Toast } from "../../../../components";
import { Fragment } from "react";

const cx = classNames.bind(styles);
const ListRoleSelect = ({ title, role, setRole, type, listPermission }) => {
  const [listRole, setListRole] = useState();
  // eslint-disable-next-line 
  const [change, setChange] = useState(false);
  const { data } = useFetchData("/permissionType/get-list-permission-type/");
  useEffect(() => {
    async function getListPMS() {
      try {
        const listData = await axiosClient.get(
          "/userFunction/get-list-user-function/"
        );
        const permission = listData.map((item) => {
          return {
            ...item,
            typePermission: data,
            isCheck: false,
          };
        });
        setListRole(permission);
      } catch (e) {
        Toast.open('Không thể lấy về danh sách chức năng', 'danger')
      }
    }
    getListPMS();
  }, [data, listPermission]);

  return (
    <div>
      <div id="__notification"></div>
      <div className={cx("header", "sub")}>
        <h1 className={cx("title", "sub-title")}>{title}</h1>
      </div>
      <div className={cx("list-role")}>
        {listRole && listRole.length > 0 ? (
          listRole.map((item, index) => {
            return (
              <Fragment key={index}>
                {item && item?.typePermission?.length > 0 && (
                  <div className={cx("role-item")} key={index}>
                    <div className={cx("check")}>
                      <span>{item.SUBJECT_NAME}</span>
                    </div>
                    <div className={cx("children")}>
                      {item?.typePermission &&
                        item?.typePermission.length > 0 &&
                        item.typePermission.map((it, index) => {
                          return (
                            <CheckBox
                              key={index}
                              role={role}
                              setRole={setRole}
                              listPermission={listPermission}
                              item={item}
                              it={it}
                              change={change}
                              checkAll={item.isCheck}
                            />
                          );
                        })}
                    </div>
                  </div>
                )}
              </Fragment>
            );
          })
        ) : (
          <div>Loading</div>
        )}
      </div>
    </div>
  );
};

export default ListRoleSelect;
